const ENDPOINT = 'GETanalyticsSections';
var AnalyticsType;
(function (AnalyticsType) {
    AnalyticsType["SONG"] = "song";
    AnalyticsType["ARTIST"] = "artist";
    AnalyticsType["ALBUM"] = "album";
    AnalyticsType["EPISODE"] = "episode";
    AnalyticsType["SHOW"] = "show";
    AnalyticsType["LABEL"] = "label";
    AnalyticsType["OWN"] = "own";
    AnalyticsType["PODCASTER"] = "podcaster";
    AnalyticsType["SUBLABEL"] = "sublabel";
})(AnalyticsType || (AnalyticsType = {}));
var ChartsIds;
(function (ChartsIds) {
    ChartsIds["SUMMARY"] = "summary";
    ChartsIds["TOP_SONGS"] = "top_songs";
    ChartsIds["STREAMS_PER_COUNTRY"] = "streams_per_country";
    ChartsIds["STREAMS_GROWTH"] = "streams_growth";
    ChartsIds["STREAMS_PER_DAY"] = "streams_per_day";
    ChartsIds["STREAMS_PER_AGE"] = "streams_per_age";
    ChartsIds["STREAMS_PER_USER_LANGUAGE"] = "streams_per_user_language";
    ChartsIds["STREAMS_PER_GENDER"] = "streams_per_gender";
    ChartsIds["STREAMS_PER_PERCENTAGE_PLAY"] = "streams_per_percentage_play";
    ChartsIds["FEATURED_IN"] = "featured_in";
    ChartsIds["SIMILAR_ARTISTS"] = "similar_artists";
    ChartsIds["PLAYS_PER_SOURCE"] = "plays_per_source";
    ChartsIds["PROFILE_SHARES"] = "profile_shares";
    ChartsIds["ANGHAMI_FOLLOWERS"] = "anghami_followers";
    ChartsIds["FOLLOWERS_PER_COUNTRY"] = "followers_per_country";
    ChartsIds["FOLLOWERS_BY_AGE"] = "followers_by_age";
    ChartsIds["FOLLOWERS_BY_GENDER"] = "followers_by_gender";
    ChartsIds["SONG_SHARES"] = "song_shares";
    ChartsIds["SONG_FEATURED_IN_TOP_PLAYLISTS"] = "song_featured_in_top_playlists";
    ChartsIds["SONG_FEATURED_IN_CURATED_PLAYLISTS"] = "song_featured_in_curated_playlists";
})(ChartsIds || (ChartsIds = {}));
var ChartTypes;
(function (ChartTypes) {
    ChartTypes["summary"] = "summary";
    ChartTypes["listChart"] = "list_chart";
    ChartTypes["lineChart"] = "line_chart";
    ChartTypes["areaChart"] = "area_chart";
    ChartTypes["table"] = "table_chart";
    ChartTypes["barChart"] = "bar_chart";
    ChartTypes["percentageChart"] = "percentage_chart";
})(ChartTypes || (ChartTypes = {}));
var ChartUnits;
(function (ChartUnits) {
    ChartUnits["PLAYS"] = "plays";
    ChartUnits["PERCENTAGE"] = "%";
    ChartUnits["FOLLOWERS"] = "followers";
    ChartUnits["SHARES"] = "shares";
    ChartUnits["STREAMS"] = "streams";
})(ChartUnits || (ChartUnits = {}));
function getAnalyticsSections(gateway, params = null) {
    if (!params)
        return;
    return gateway.get(getAnalyticsSections.endpoint, params);
}
getAnalyticsSections.endpoint = ENDPOINT;

export { AnalyticsType, ChartTypes, ChartUnits, ChartsIds, getAnalyticsSections as default };
//# sourceMappingURL=getAnalyticsSections.js.map
